var map = {
	"./decidim/challenges/decidim_challenges_icon.svg": 62951,
	"./decidim/sdgs/ods-01.svg": 76528,
	"./decidim/sdgs/ods-02.svg": 65923,
	"./decidim/sdgs/ods-03.svg": 62610,
	"./decidim/sdgs/ods-04.svg": 96541,
	"./decidim/sdgs/ods-05.svg": 67996,
	"./decidim/sdgs/ods-06.svg": 70319,
	"./decidim/sdgs/ods-07.svg": 50270,
	"./decidim/sdgs/ods-08.svg": 50713,
	"./decidim/sdgs/ods-09.svg": 54696,
	"./decidim/sdgs/ods-10.svg": 90518,
	"./decidim/sdgs/ods-11.svg": 77639,
	"./decidim/sdgs/ods-12.svg": 6132,
	"./decidim/sdgs/ods-13.svg": 31765,
	"./decidim/sdgs/ods-14.svg": 21354,
	"./decidim/sdgs/ods-15.svg": 39195,
	"./decidim/sdgs/ods-16.svg": 57832,
	"./decidim/sdgs/ods-17.svg": 65753,
	"./decidim/sdgs/sdg-wheel.png": 9481,
	"./decidim/sdgs/un_emblem_square.png": 62203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89036;